<template>
    <b-navbar shadow>
        <template #brand>
            <b-navbar-item>
                <img :src="require(`@/assets/logo-villa-mobile.svg`)"
                    alt="Lightweight UI components for Vue.js based on Bulma" />
            </b-navbar-item>
        </template>
        <template #start>
            <b-navbar-item tag="router-link"
                :to="{ path: '/progressOrder' }">รายการสั่งซื้อกำลังดำเนินการ</b-navbar-item>
            <b-navbar-item tag="router-link"
                :to="{ path: '/shippingOrder' }">รายการสั่งซื้อที่กำลังจัดส่ง</b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/historyOrder' }">ประวัติรายการสั่งซื้อ</b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/lalamoveTracking' }">Lalamove</b-navbar-item>
        </template>
        <template #end>
            <b-navbar-item style="margin-right: 5px" class="dev-mode" tag="router-link" :to="{ path: '/createDriver' }">
                <!-- <b-button class="is-warning" @click="signOut"> -->
                    Create driver
                    <!-- Sign out -->
                <!-- </b-button> -->
            </b-navbar-item>
            <b-navbar-item style="margin-right: 5px" class="dev-mode" tag="router-link"
                :to="{ path: '/createOrder' }">
                <!-- <b-button class="is-warning" @click="signOut"> -->
                    Create order
                <!-- </b-button> -->
            </b-navbar-item>
            <b-navbar-item class="dev-mode" tag="router-link" :to="{ path: '/manualEditOrderStatus' }">Manual edit order
                status
            </b-navbar-item>
            <b-navbar-item>
                <b-button class="is-danger" icon-left="logout" @click="signOut">
                    Sign out
                </b-button>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
export default {
    methods: {
        signOut() {
            // Your sign out logic here
            // For example:
            this.$root.$emit('signout');
        }
    }
}
</script>

<style scoped>
.navbar {
    min-height: 4.25rem;
}

.dev-mode {
    background-color: #ffe089 !important;
    color: #4c4229 !important;
}

.navbar.has-shadow {
    -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    -moz-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
</style>